import React from 'react';
import { useDispatch } from 'react-redux';
import { i18next } from '@yola/ws-sdk';
import PropTypes from 'prop-types';
import dialogs from 'yola-editor/src/js/modules/dialogs';
import ResultDialog from '../components/result-dialog';

const defaultCaptions = {};

function PurchaseSuccessDialogContainer({
  captions = defaultCaptions,
  onClose = null,
  onDialogMainAction,
}) {
  const computedCaptions = {
    title: i18next.t('Order completed'),
    description: i18next.t('Thank you. Your order has been completed.'),
    close: i18next.t('OK'),
    ...captions,
  };

  const dispatch = useDispatch();

  function handleClose() {
    onDialogMainAction();
    if (onClose) {
      onClose();
    } else {
      dispatch(dialogs.actions.hide());
    }
  }

  return (
    <ResultDialog
      captions={computedCaptions}
      imgClass="dialog__img--success"
      onClose={handleClose}
    />
  );
}

PurchaseSuccessDialogContainer.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    close: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onDialogMainAction: PropTypes.func.isRequired,
};

export default PurchaseSuccessDialogContainer;
